module.exports = __webpack_public_path__ + "static/the-uncommon-reader-13e7cc351f20ace3a48d2656aeeee200.jpg";